/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Fuel_LevelInputs */

const vi_fleet_fuel_level = /** @type {(inputs: Fleet_Fuel_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiên liệu`)
};

/**

* @param {Fleet_Fuel_LevelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_fuel_level = /** @type {((inputs?: Fleet_Fuel_LevelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Fuel_LevelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_fuel_level(inputs)
});